import { Text } from '@mobi/ds';

import './Faq.scss';
import FaqStructured from './components/FaqStructured';

const Faq = ({ data }) => {
  return (
    <section className="faq">
      <div className="faq__container container">
        <Text weight={700} as="h3" className="faq__title">
          Como podemos te ajudar?
        </Text>
        <div className="faq__content">
          <FaqStructured data={data} />
        </div>
      </div>
    </section>
  );
};

export default Faq;
